<script lang="ts" setup>
	/**
	 * Sélecteur de langue compact, pour la barre d'application.
	 *
	 * La borne utilise sa propre barre, en boutons pleine largeur : ici, la place
	 * est comptée et un menu suffit.
	 */
	import { useI18n } from 'vue-i18n';
	import { setLocale } from '@/plugins/i18n';

	const { locale } = useI18n();

	const LANGUAGES = [
		{ code: 'fr', label: 'Français', flag: '🇫🇷' },
		{ code: 'en', label: 'English', flag: '🇬🇧' },
		{ code: 'it', label: 'Italiano', flag: '🇮🇹' },
	];
</script>

<template>
	<v-menu>
		<template #activator="{ props }">
			<v-btn v-bind="props" variant="text" size="small" class="text-uppercase">
				{{ locale }}
			</v-btn>
		</template>

		<v-list density="compact">
			<v-list-item
				v-for="language of LANGUAGES"
				:key="language.code"
				:active="locale === language.code"
				@click="setLocale(language.code)"
			>
				<template #prepend>
					<span class="mr-2">{{ language.flag }}</span>
				</template>
				<v-list-item-title>{{ language.label }}</v-list-item-title>
			</v-list-item>
		</v-list>
	</v-menu>
</template>
